import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

// getters
const getters = {}

// actions
const actions = {
    // get records (server-side pagination)
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)

        state.filterData = filterData

        let params = {
            page: page?.current,
            page_limit: page?.pageSize,
        }

        if (state.filterData) {
            params = {...params, ...state.filterData}
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_discount_coupon'), {
            params: params,
        })

        const {data, meta} = res.data

        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({state, dispatch}) {
        dispatch('get', {
            page: state.table.pagination,
            filterData: state.filterData,
        })
    },

    // show single record
    async show({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_discount_coupon') + '/' + id)
        return response.data.data
    },

    // generate a unique coupon code
    async generateCode({commit}, {length = 8} = {}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_discount_coupon_generate_code'), {
            params: {length},
        })
        return response.data
    },

    // create SINGLE coupon (returns JSON)
    async create({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_discount_coupon'), data)
        return response.data
    },

    // create MULTI coupons (backend returns an Excel file with generated codes)
    async createMulti({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_discount_coupon'), data, {
            responseType: 'blob',
        })
        return response
    },

    // update coupon (code / discount_type / discount_value are immutable on backend)
    async update({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_discount_coupon') + '/' + id, data)
        return response.data
    },

    // delete coupon(s)
    async delete({dispatch}, {id}) {
        let successDeleted = []
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_discount_coupon') + '/' + id[i])
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                    successDeleted.push(id[i])
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted
        }
    },

    // export list (returns file blob)
    async exportList({state}, {filterData} = {}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_discount_coupon_export'), {
            params: filterData ?? state.filterData ?? {},
            responseType: 'blob',
        })
        return response
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
